import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import appConfig from "utils/appConfig";

function createMiddlewares() {
    const middlewares = [applyMiddleware(thunk)];
    const { reduxLoggerEnabled, reduxDevToolsEnabled } = appConfig();

    // Make sure redux-logger is applied after all standard middleware but before
    // redux dev tools, or it will end up logging thunks/promises/devtools events.
    if (reduxLoggerEnabled) {
        const { createLogger } = require("redux-logger");

        middlewares.push(applyMiddleware(createLogger({ collapsed: true })));
    }

    if (reduxDevToolsEnabled && window.__REDUX_DEVTOOLS_EXTENSION__) {
        middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    }

    return compose.apply(null, middlewares);
}

export default function getStore(rootReducer) {
    return createStore(
        rootReducer,
        { config: appConfig() },
        createMiddlewares()
    );
}
